module.exports = __webpack_public_path__ + "resources/img/img_secureguard2.7770bd326450bad4dd4d96dd1be5f61c.png";